import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LazyImgModule } from '@core-mkt/services/lazy-load/lazy-load.module';
import { QueryParamModule } from '@core-mkt/services/query-param/query-param.module';
import { VisionButtonModule } from '@core-mkt/shared/components/vision-button/vision-button.module';
import { SliderCardComponent } from './slider-card/slider-card.component';

@NgModule({
  exports: [SliderCardComponent],
  imports: [CommonModule, QueryParamModule, LazyImgModule, VisionButtonModule, SliderCardComponent],
})
export class SliderCardModule {}
